import React, { useState } from "preact/compat";

import { translation } from './locales/en/translation'; 
import { ModalBody } from "./components/💎Atoms/Modal/Body/ModalBody";
import { Modal } from "./components/💠Molecules/Modal/Modal";
import { closeModal } from ".";

function ModalMessage(props: any) {
    const [tg, setTg] = useState(true);

    function onClose() {
        setTg(!tg)
        closeModal()
    }

    return (
        <Modal 
            modalId="betslip-modal" 
            modalToggle={tg} 
            modalStyle="modal-dialog-centered col-12 col-md-7 col-lg-5 col-xl-4 col-xxl-3 m-0">
            <ModalBody className="d-flex justify-content-between align-items-start p-0" onClose={onClose}>
                <div className="col-12">
                    <div><i class="mat-icon-slip1"></i> <span class='visually-hidden'>Trash can icon</span></div>
                    <div className="h5 mt-2 mb-2">{props.t.heading}</div>
                    <ul className='ps-3'>
                        {props.t.features.map((score: any) => (
                            <li className='mb-1'><small>{score.replaceAll('[LOGO]', "")} {score.indexOf('[LOGO]') > 0 ? <span className="mat-icon-quick-logo me-1"></span> : "" }</small></li>
                        ))}
                    </ul>
                    <p className="mb-2">
                        <small className='d-flex justify-content-start align-items-center'>
                            <span className="mat-icon-quick-icon me-1"></span>
                            {props.t.description.replaceAll('[ICON]', "")}
                        </small>
                    </p>
                    <p className="fs-8 text-gray mb-3">{props.t.disclaimer}</p>
                    <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal" onClick={onClose}>{props.t.cta}</button>
                </div>
            </ModalBody>
        </Modal>
    )
}

export const MessageApp = <ModalMessage t={translation.pop_up_modal} />;
